export const API_BASE = 'https://api.themrconstruction.com';

// ── Auth token (set by App after login, cleared on logout) ────────────────────
let AUTH_TOKEN = null;
export function setAuthToken(t) { AUTH_TOKEN = t || null; }
export function getAuthToken()  { return AUTH_TOKEN; }

// ── Main api() — connects directly to your PHP backend ────────────────────────
// No mock data. No fallback. All data comes from your MySQL database.
// If the server is unreachable, the UI shows an error — nothing is fabricated.

export async function api(path, method = 'GET', body = null) {
    const opts = {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...(AUTH_TOKEN ? { Authorization: `Bearer ${AUTH_TOKEN}` } : {}),
        },
    };
    if (body) opts.body = JSON.stringify(body);

    const res = await fetch(`${API_BASE}/${path}`, opts);

    if (!res.ok) {
        let msg = `HTTP ${res.status}`;
        try {
            const errData = await res.json();
            msg = errData.error || errData.message || JSON.stringify(errData);
        } catch {
            msg = await res.text().catch(() => `HTTP ${res.status}`);
        }
        throw new Error(msg);
    }

    return res.json();
}